import { use_slice_generation } from '@/hooks/store/use_slices';
import { DTO_TREE__generations_sliding_window } from '@shared/dto/generation/tree/DTO_TREE__generations_sliding_window';
import { useMemo, useState } from 'react';
import { G_HEADER__generations_history_column } from './G_HEADER__generations_history_column';
import { HOOK__user_task_generations_tree } from './HOOK__user_task_generations_tree';

interface PROPS {}

export function G_HEADER__generations_history({}: PROPS) {
  /*
   * STORE
   */
  const { generation_current } = use_slice_generation(['generation_current']);

  /*
   * STATE
   */

  const [is_hovered, set_is_hovered] = useState(false);

  const { generations_tree } = HOOK__user_task_generations_tree();

  const sliding_window = useMemo(() => get_sliding_window(), [generations_tree, generation_current]);
  const is_any_column_has_more_2_items = sliding_window.columns.some(column => column.length > 2);

  /*
   * METHODS
   */
  function get_sliding_window() {
    if (generation_current.is_stub()) return new DTO_TREE__generations_sliding_window();
    if (generations_tree.is_stub()) return new DTO_TREE__generations_sliding_window();
    if (!generations_tree.items_map.has(generation_current._id)) return new DTO_TREE__generations_sliding_window(); //not loaded yet

    //todo:review and remove
    // if (!selectedId) {
    //   // Fallback if nothing is selected: Show root items in a single column
    //   return [treeInstance.get_children_for(ENUM__string_id_empty.OBJECT_ID)];
    // }

    let out = generations_tree.get_sliding_window(generation_current._id, 4);
    return out;
  }

  /*
   * HTML
   */

  if (generations_tree.is_stub()) return null;

  return (
    <div
      className={`   flex items-start gap-0
        p-0.5 
        overflow-y-auto
        flex-1  
        bg-bar
        no-scrollbar
        
        transition-all duration-300 ease-in-out
        border-b border-x 
        relative
        ${is_hovered && is_any_column_has_more_2_items ? 'h-fit max-h-[220px] shadow-2xl  z-50 rounded-b-xl  border-component-border' : ' border-transparent'}`}
      onMouseEnter={() => set_is_hovered(true)}
      onMouseLeave={() => set_is_hovered(false)}
    >
      {sliding_window.columns.map((items, index) => {
        return (
          <G_HEADER__generations_history_column
            key={`G_HEADER__generations_history_column_${index}`}
            {...{ items, sliding_window }}
            is_bar_hovered={is_hovered}
          />
        );
      })}
    </div>
  );
}
